import MakeTag from "../makeTag/MakeTag";
export default function UnityTag() {
  return (<>
    <MakeTag tagText="Unity Engine" color="#ccc" />
    <MakeTag tagText="C#" color="#996ece" />

  </>);
}